<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>分播机器列表</div>
      <el-button class="icon-fresh" type="primary" @click="beforeAddMachine">
        新增
      </el-button>
    </div>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            max-height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="machine_id"
              label="设备id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="machine_no"
              label="设备编号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="grid_num"
              label="格口数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="ip"
              label="ip"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="port"
              label="端口号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="更新人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="update_time"
              label="更新时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="grid_is_check_one_out"
              label="一键打包"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="editMachine(scope.row)"
                  >修改
                </el-button>
                <el-button
                  type="text"
                  style="color: #f56c6c"
                  size="small"
                  @click="delMachine(scope.row)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <edit
      v-if="visible"
      :machine_id="form.machine_id"
      :machine_no="form.machine_no"
      :grid_num="form.grid_num"
      :ip="form.ip"
      :port="form.port"
      :is_check_one_out="form.is_check_one_out"
      @onCloseDialog="closeBox"
    ></edit>

    <!-- 分播方案配置 -->
    <h3>分播方案配置</h3>
    <div class="machine_cut_case_setting">
      <el-form ref="form" :model="machine_cut_case_setting" inline>
        <el-form-item>
          <el-select
            v-model="machine_cut_case_setting.machine_id"
            placeholder="选择设备"
            @change="getCutCase"
          >
            <el-option
              v-for="item in resData.list"
              :key="item.machine_id"
              :value="item.machine_id"
              :label="item.machine_no"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="machine_cut_case_setting.machine_cut_type"
            placeholder="选择分播类型"
            @change="getCutCase"
          >
            <el-option
              v-for="(item, index) in resData.machine_cut_type"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            style="margin-left: 50px"
            @click="setCaseName"
            >增加分播方案
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveCutCase">保存</el-button>
        </el-form-item>
      </el-form>
      <!-- <div style="width: 100%; margin-top: 30px; display: flex"> -->
      <el-row :gutter="16">
        <el-col
          v-for="(item, key) in machine_cut_case_setting.case"
          :key="key"
          :span="6"
        >
          <el-card style="width: 100%">
            <div slot="header" class="clearfix">
              <span
                v-if="
                  machine_cut_case_setting.machine_cut_type ===
                  DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION
                "
              >
                入库分播包裹号必填
                <el-switch
                  v-model="machine_cut_case_setting.case[0].is_need_package"
                  active-color="#409EFF"
                  inactive-color="#999"
                  active-value="1"
                  inactive-value="0"
                >
                </el-switch
              ></span>
              <span v-else>&nbsp;</span>
              <el-button
                type="text"
                style="
                  font-size: 20px;
                  font-weight: 800;
                  float: right;
                  padding: 3px 0;
                "
                @click="rename(key)"
                >{{ item.case_name }}
                <i class="el-icon-edit" style="font-size: 20px" />
              </el-button>
            </div>

            <!--  方案 -->
            <el-table :data="item.grid_setting" border>
              <el-table-column
                prop="grid_no"
                label="格口号"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="cut_type"
                label="分播类型"
                align="center"
              ></el-table-column>
              <el-table-column label="" align="center">
                <template slot="header">
                  格口配置
                  <i
                    v-if="
                      ![
                        DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION,
                        DISTRIBUTION_TYPE.MEDIAN_DISTRIBUTION_GROUP,
                      ].includes(machine_cut_case_setting.machine_cut_type)
                    "
                    class="el-icon-close"
                    style="
                      color: #f00;
                      float: right;
                      font-size: 20px;
                      font-weight: 800;
                      cursor: pointer;
                    "
                    @click="removeCase(key)"
                  />
                </template>
                <template slot-scope="scope">
                  <!-- 入库类型的时候是单选, 次品员分播类型是多选 -->
                  <el-select
                    v-if="
                      [
                        '1',
                        '2',
                        '4',
                        DISTRIBUTION_TYPE.MEDIAN_DISTRIBUTION_GROUP,
                      ].includes(machine_cut_case_setting.machine_cut_type)
                    "
                    :value="scope.row.grid_type"
                    :disabled="['1', '2'].includes(scope.row.is_sc_grid)"
                    size="small"
                    filterable
                    :multiple="
                      ['2', '4'].includes(
                        machine_cut_case_setting.machine_cut_type
                      )
                    "
                    placeholder="请选择"
                    @change="onGridTypeChange($event, key, scope.row)"
                  >
                    <el-option
                      v-for="gt in machine_grid_type[
                        machine_cut_case_setting.machine_cut_type
                      ]"
                      :key="gt.value"
                      :value="gt.value"
                      :label="gt.label"
                    >
                    </el-option>
                  </el-select>
                  <!-- 中分位分播联级多选 -->
                  <el-cascader
                    v-else
                    v-model="scope.row.grid_type"
                    filterable
                    :options="
                      machine_grid_type[
                        machine_cut_case_setting.machine_cut_type
                      ]
                    "
                    :show-all-levels="false"
                    :props="{
                      expandTrigger: 'hover',
                      multiple: true,
                    }"
                  ></el-cascader>
                </template>
              </el-table-column>
              <el-table-column
                v-if="
                  machine_cut_case_setting.machine_cut_type ===
                    DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION ||
                  machine_cut_case_setting.machine_cut_type ===
                    DISTRIBUTION_TYPE.MEDIAN_DISTRIBUTION_GROUP
                "
                width="120"
              >
                <template slot="header">
                  格口件数上限(仅限正常标)
                  <i
                    class="el-icon-close"
                    style="
                      color: #f00;
                      font-size: 20px;
                      font-weight: 800;
                      cursor: pointer;
                      position: absolute;
                      rigth: 0;
                      top: 0;
                    "
                    @click="removeCase(key)"
                  />
                </template>
                <template slot-scope="scope">
                  <!-- 正常标格口才需要设置数量 -->
                  <el-input-number
                    v-if="
                      scope.row.grid_type == 1 ||
                      machine_cut_case_setting.machine_cut_type ===
                        DISTRIBUTION_TYPE.MEDIAN_DISTRIBUTION_GROUP
                    "
                    v-model="scope.row.max_cut_num"
                    :controls="false"
                    style="width: 90px"
                    size="small"
                    :min="0"
                  ></el-input-number>
                </template>
              </el-table-column>
              <!-- 按次品员分播才有"其他配置"下拉选项 -->
              <el-table-column
                v-if="
                  [2, 4].includes(
                    Number(machine_cut_case_setting.machine_cut_type)
                  )
                "
                :label="showOther ? '其他配置' : '不出库格口'"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <div v-if="showOther">
                    <el-select
                      :value="scope.row.is_sc_grid"
                      clearable
                      @change="
                        selectScGrid($event, scope.row, item.grid_setting)
                      "
                    >
                      <el-option label="色差" value="1"></el-option>
                      <el-option label="微次" value="2"></el-option>
                      <el-option label="不出库格口" value="3"></el-option>
                    </el-select>
                  </div>
                  <div v-else>
                    <el-checkbox
                      v-model="scope.row.is_sc_grid"
                      true-label="1"
                      false-label="0"
                      @change="
                        checkScGrid($event, item.grid_setting, scope.$index)
                      "
                    ></el-checkbox>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import Edit from "./components/edit.vue";

const DISTRIBUTION_TYPE = {
  INBOUND_DISTRIBUTION: "1", // 入库分播
  DEFECTIVE_INSPECTOR_DISTRIBUTION: "2", // 按次品员分播
  MEDIAN_DISTRIBUTION: "3", // 按中分位
  RETURN_DISTRIBUTION: "4", // 按退供员
  MEDIAN_DISTRIBUTION_GROUP: "5", // 按中分位分组
};

// 其他配置选项重复提醒
const GRID_SELECT_TIPS = [
  "只允许一个格口“其他配置”选择“色差”",
  "只允许一个格口“其他配置”选择“微次”",
  "只允许一个格口“其他配置”选择“不出库格口”",
];
// 格口类型
const GRID_TYPE = {
  DEFECTIVE_AFTER_SALES: "8", // 售后次品
};

export default {
  components: {
    Edit,
  },
  data() {
    return {
      DISTRIBUTION_TYPE,
      resData: { is_need_package: "0" },
      form: {
        machine_no: "",
        machine_id: "",
        grid_num: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Machine/machineList",
      filterFold: false,
      supplyData: null,
      visible: false,
      senders: [],
      sender: "",
      cpcode: "",
      // 设备分播配置
      machine_cut_case_setting: {
        machine_id: "", // 设备id
        machine_cut_type: "", // 分播类型
        case: [], // 方案 [{case_id:0,case: []}]
      },
      // 格口配置的下拉
      machine_grid_type: {},
      machine_case_name: "",
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
    showOther() {
      return (
        this.machine_cut_case_setting.machine_cut_type ===
        DISTRIBUTION_TYPE.DEFECTIVE_INSPECTOR_DISTRIBUTION
      );
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    handleCurrentChange(val) {
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    beforeAddMachine() {
      this.form.machine_no = "";
      this.form.machine_id = "";
      this.form.grid_num = "";
      this.form.ip = "";
      this.form.port = "";
      this.form.is_check_one_out = "";
      this.visible = true;
    },
    closeBox() {
      this.fetchData();
      this.visible = false;
    },

    editMachine(row) {
      this.form.machine_no = row.machine_no;
      this.form.machine_id = row.machine_id;
      this.form.grid_num = row.grid_num;
      this.form.ip = row.ip;
      this.form.port = row.port;
      this.form.is_check_one_out = row.is_check_one_out;
      this.visible = true;
    },
    delMachine(row) {
      this.$confirm(`确认要删除此设备?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "不不不",
        type: "warning",
      }).then(() => {
        this.form.machine_id = row.machine_id;
        this.$http.post("/erp/machine/delMachine", this.form).then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.visible = false;
            this.form.machine_id = "";
            this.fetchData();
          }
        });
      });
    },

    // 获取分播方案
    getCutCase() {
      // 两个都选完才获取数据
      if (
        !this.machine_cut_case_setting.machine_cut_type ||
        !this.machine_cut_case_setting.machine_id
      ) {
        return;
      }
      // 先重置掉
      this.$set(this.machine_cut_case_setting, "case", []);
      this.$http
        .post("/erp/Machine/getMachineCutCaseDetail", {
          machine_id: this.machine_cut_case_setting.machine_id,
          machine_cut_type: this.machine_cut_case_setting.machine_cut_type,
        })
        .then((rs) => {
          const { code, data } = rs.data;
          if (code !== 200) {
            return this.$message.e(rs.data.msg);
          }
          // 将 is_sc_grid 等于 0的值改成空字符串， 这样筛选项就不会显示0
          let newData = data;
          if (this.machine_cut_case_setting.machine_cut_type === "2") {
            newData = data.map((item) => {
              return {
                ...item,
                grid_setting: item.grid_setting.map((v) => {
                  return {
                    ...v,
                    is_sc_grid: v.is_sc_grid === "0" ? "" : v.is_sc_grid,
                  };
                }),
              };
            });
          }
          this.$set(this.machine_cut_case_setting, "case", newData);
        });
      this.getGridTypeSelection();
    },

    // 方案名的弹窗
    namePop() {
      const m = this.getMachinefield("machine_no");
      const t =
        this.resData.machine_cut_type[
          +this.machine_cut_case_setting.machine_cut_type - 1
        ].label;

      return this.$prompt(
        `<span style="font-size:16px">设备编号：${m}</span><br><span style="font-size:16px;margin-top:10px">分播类型：${t}</span>`,
        "输入方案名",
        {
          closeOnClickModal: false,
          inputPlaceholder: "请输入方案名",
          inputPattern: /^([0-9]|[a-zA-Z]|[\u4e00-\u9fa5]){1,20}$/, // 限制中文数字英文
          inputErrorMessage: "限制输入20个中文或英文或数字",
          dangerouslyUseHTMLString: true,
          inputValue: this.machine_case_name,
        }
      );
    },

    // 重命名方案名
    rename(case_index) {
      this.machine_case_name =
        this.machine_cut_case_setting.case[case_index].case_name;
      this.namePop().then((rs) => {
        this.$set(
          this.machine_cut_case_setting.case[case_index],
          "case_name",
          rs.value
        );
        this.machine_case_name = "";
      });
    },

    // 增加分播方案 - 输入方案名
    // @param type 1:重名,添加
    setCaseName() {
      if (!this.machine_cut_case_setting.machine_cut_type) {
        return this.$message.e("请选择分播类型");
      }
      if (!this.machine_cut_case_setting.machine_id) {
        return this.$message.e("请选择设备");
      }

      // 判断分播方案的上限
      const len = this.machine_cut_case_setting.case.length;
      // 入库分播方案只能有一个
      if (
        this.machine_cut_case_setting.machine_cut_type ===
          DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION &&
        len >= 1
      ) {
        return this.$message.e("入库类型的分播方案只能设置一套, 不可再添加");
      }
      if (len >= 3) {
        return this.$message.e("此类型的分播方案最多设置三套, 不可再添加");
      }
      this.namePop().then((rs) => {
        this.machine_case_name = rs.value;
        this.addCutCase();
      });
    },

    // 增加分播方案
    addCutCase() {
      // 获取格口号 才能往下走
      this.$http
        .post("/erp/Machine/getGridByMachine", {
          machine_id: this.machine_cut_case_setting.machine_id,
        })
        .then((rs) => {
          if (rs.data.code != 200) {
            return this.$message.e(rs.data.msg);
          }
          const grids = rs.data.data;
          grids.forEach((v) => {
            v.case_detail_id = 0;
            v.cut_type =
              this.resData.machine_cut_type[
                +this.machine_cut_case_setting.machine_cut_type - 1
              ].label; // 分播类型
            v.grid_type =
              this.machine_cut_case_setting.machine_cut_type ===
              DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION
                ? ""
                : []; // 格口类型 , 只有入库分播的时候是单选的
            v.max_cut_num = 0; // 最大分播数量
            v.is_sc_grid = "0";
          });
          // 分播类型做为下标
          this.machine_cut_case_setting.case.push({
            case_id: 0, // 配置id 0 为新增
            case_name: this.machine_case_name.trim(),
            grid_setting: grids,
          });
          this.machine_case_name = "";
        });
    },

    // 保存分播方案
    saveCutCase() {
      if (this.machine_cut_case_setting.case.length == 0) {
        return this.$message.error("没有需要保存的数据");
      }
      this.$http
        .post("/erp/Machine/saveMachineCutCase", this.machine_cut_case_setting)
        .then((rs) => {
          if (rs.data.code != 200) return this.$message.e(rs.data.msg);
          this.getCutCase();
          return this.$message.success(rs.data.msg);
        });
    },

    // 获取格口配置的下拉
    getGridTypeSelection() {
      if (
        this.machine_grid_type[this.machine_cut_case_setting.machine_cut_type]
      ) {
        return this.$set(
          this.machine_grid_type,
          this.machine_cut_case_setting.machine_cut_type,
          this.machine_grid_type[this.machine_cut_case_setting.machine_cut_type]
        );
      }
      // 重置为空
      this.$set(
        this.machine_grid_type,
        this.machine_cut_case_setting.machine_cut_type,
        []
      );
      this.$http
        .post("/erp/Machine/getMachineCutGridType", {
          machine_cut_type: this.machine_cut_case_setting.machine_cut_type,
        })
        .then((rs) => {
          if (rs.data.code != 200) {
            return this.$message.error(rs.data.msg);
          }
          this.$set(
            this.machine_grid_type,
            this.machine_cut_case_setting.machine_cut_type,
            rs.data.data
          );
        });
    },

    // 获取设备信息
    getMachinefield(field) {
      let rs = null;
      this.resData.list.every((v) => {
        if (v.machine_id == this.machine_cut_case_setting.machine_id) {
          rs = v[field];
          return false;
        }
        return true;
      });
      return rs;
    },

    // 删除分播方案
    removeCase(key) {
      const { case_id } = this.machine_cut_case_setting.case[key];
      const { case_name } = this.machine_cut_case_setting.case[key];
      let msg = `是否确定删除方案: ${case_name}?`;
      if (case_id == 0) {
        msg = `方案: ${case_name}, 尚未保存, 是否确定删除?`;
      }
      this.$confirm(msg, "删除方案", {
        closeOnClickModal: false,
      }).then((rs) => {
        if (case_id == 0) {
          this.machine_cut_case_setting.case.splice(key, 1);
          this.$message.success("删除方案成功");
        } else {
          this.$http.post("/erp/Machine/removeCase", { case_id }).then((rs) => {
            if (rs.data.code != 200) {
              return this.$message.e(rs.data.msg);
            }
            this.$message.success("删除方案成功");
            this.getCutCase();
          });
        }
      });
      // console.log(this.machine_cut_case_setting.case[key])
    },

    // 勾选色差
    checkScGrid(value, setting, self_index) {
      // console.log(e);
      if (value == 1) {
        // 如果勾选了 则把选中的次品员去掉 且禁用掉选择框
        setting[self_index].grid_type = [];
        setting.forEach((v, index) => {
          // 把其他格口的勾选给去掉, 只能勾选一个格口
          if (self_index != index && v.is_sc_grid == "1") {
            v.is_sc_grid = "0";
          }
        });
      }
    },
    // 更改其他配置项
    selectScGrid(value, scoped, gridList) {
      // console.log("vaule", value, scoped, gridList);
      const hasValueItem = gridList.find((item) => item.is_sc_grid === value);
      console.log("hasValueItem", hasValueItem);
      if (hasValueItem) {
        // 排除等于空字符串的情况
        if (hasValueItem.is_sc_grid !== "") {
          this.$message.warning(GRID_SELECT_TIPS[value - 1]);
          hasValueItem.is_sc_grid = "";
        }
      }

      scoped.is_sc_grid = value;
      scoped.grid_type = [];
    },
    // 监听更换格口配置
    onGridTypeChange(value, index, scope) {
      const { case: caseList } = this.machine_cut_case_setting;
      const gridSetting = caseList[index].grid_setting.map((item) => {
        if (item.grid_id === scope.grid_id) {
          return { ...item, grid_type: value };
        }
        // 判断列表格口配置中是否已存在售后次品类型，若有则清空。
        if (
          value === GRID_TYPE.DEFECTIVE_AFTER_SALES &&
          item.grid_type === GRID_TYPE.DEFECTIVE_AFTER_SALES
        ) {
          this.$message.warning("只允许一个格口配置为售后次品");
          return { ...item, grid_type: "" };
        }
        return item;
      });
      caseList[index].grid_setting = gridSetting;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/machine/machineList.vue